import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { connectFC } from '../../../utils/connectFC';
import { PromotionFooterFC, PromotionFooterFCProps } from './PromotionFooterFC';

const useStrings = (): PromotionFooterFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      moreDetails: intl.formatMessage({ id: 'components.PromotionFooter.moreDetails' }),
      termsAndConditions: intl.formatMessage({
        id: 'components.PromotionFooter.termsAndConditionsLink',
      }),
      omnibusDisclaimer: intl.formatMessage({
        id: 'components.PromotionFooter.omnibusDisclaimerV2',
      }),
    }),
    [intl],
  );
};

export type PromotionFooterProps = Omit<PromotionFooterFCProps, 'strings' | 'tacLink'>;

export const PromotionFooter = connectFC(PromotionFooterFC, (props: PromotionFooterProps) => {
  const strings = useStrings();
  const url = 'https://food.bolt.eu/en-us/legal/';

  return { ...props, strings, tacLink: url };
});
